import styled from '@emotion/styled';
import { Divider } from 'antd';
import React from 'react';
import { IconSort } from '../../../assets';

interface IndexColumnProps {
  value: number;
  className?: string;
}

export default React.memo((props: IndexColumnProps) => {
  return (
    <StyledIndexColumnSortContent className={props?.className || ''}>
      <Divider className="divider-left" type="vertical" />
      <div className="d-flex align-items-center justify-content-center">
        <IconSort />
        <b style={{ marginLeft: '5px' }}>{props.value + 1}</b>
      </div>
      <Divider className="divider-right" type="vertical" />
    </StyledIndexColumnSortContent>
  );
});

const StyledIndexColumnSortContent = styled.div`
  .divider-right {
    position: absolute;
    right: -0.5rem;
    height: calc(100% - 1rem);
    top: 0.5rem;
    border-left-width: 2px;
  }

  .divider-left {
    position: absolute;
    left: -0.5rem;
    height: calc(100% - 1rem);
    top: 0.5rem;
    border-left-width: 2px;
  }
`;
